export default "__VITE_ASSET__b5a0ab38__"